export const FILTER = 'FILTER'
export const SELECTION = 'SELECTION'
export const HELP = 'HELP'
export const STOMPUNKT = 'STOMPUNKT'
export const EXPORT = 'EXPORT'



// WEBPACK FOOTER //
// ./src/constants/pages.js